import React, { useState } from 'react';
import { XIcon } from 'lucide-react';
import { Story } from '../data/mockData';
import { RepublishOptionsModal } from './RepublishOptionsModal';
import { DownloadContentModal } from './DownloadContentModal';
interface StoryPreviewModalProps {
  story: Story;
  onClose: () => void;
  onRepublish: (story: Story) => void;
}
export function StoryPreviewModal({
  story,
  onClose,
  onRepublish
}: StoryPreviewModalProps) {
  const [showRepublishOptions, setShowRepublishOptions] = useState(false);
  const [showDownloadContent, setShowDownloadContent] = useState(false);
  const handleRepublishClick = () => {
    setShowRepublishOptions(true);
  };
  const handleSelectApi = () => {
    setShowRepublishOptions(false);
    onRepublish(story);
    onClose();
  };
  const handleSelectDownload = () => {
    setShowRepublishOptions(false);
    setShowDownloadContent(true);
  };
  const handleCloseDownload = () => {
    setShowDownloadContent(false);
    onClose();
  };
  return <>
      <div className="fixed inset-0 bg-black bg-opacity-60 flex items-center justify-center z-50 p-4 backdrop-blur-sm" data-id="element-156">
        <div className="bg-white rounded-2xl max-w-4xl w-full max-h-[90vh] overflow-hidden shadow-card-lg" data-id="element-157">
          {/* Header */}
          <div className="sticky top-0 bg-white border-b border-neutral-200 px-8 py-6 flex justify-between items-center" data-id="element-158">
            <h2 className="text-2xl font-bold text-display text-neutral-900" data-id="element-159">
              Story Preview
            </h2>
            <button onClick={onClose} className="p-2 hover:bg-neutral-100 rounded-lg transition-colors" data-id="element-160">
              <XIcon className="w-6 h-6 text-neutral-600" data-id="element-161" />
            </button>
          </div>
          {/* Content */}
          <div className="overflow-auto max-h-[calc(90vh-180px)] px-8 py-8" data-id="element-162">
            <div className="space-y-6" data-id="element-163">
              {/* Meta */}
              <div className="flex items-center gap-3 flex-wrap" data-id="element-164">
                <span className="px-3 py-1 rounded-full text-sm font-semibold" style={{
                backgroundColor: 'rgba(2, 137, 187, 0.1)',
                color: '#0289BB'
              }} data-id="element-165">
                  {story.category}
                </span>
                <span className="px-3 py-1 bg-neutral-100 text-neutral-700 rounded-full text-sm font-medium" data-id="element-166">
                  {story.language}
                </span>
                <span className="text-sm text-neutral-500" data-id="element-167">
                  {new Date(story.date).toLocaleDateString('en-US', {
                  month: 'long',
                  day: 'numeric',
                  year: 'numeric'
                })}
                </span>
              </div>
              {/* Title */}
              <h1 className="text-4xl font-bold text-display text-neutral-900 leading-tight" data-id="element-168">
                {story.title}
              </h1>
              {/* Author & Source */}
              <div className="flex items-center gap-4 pb-6 border-b border-neutral-200" data-id="element-169">
                <div className="w-12 h-12 rounded-full flex items-center justify-center" style={{
                backgroundColor: 'rgba(2, 137, 187, 0.1)'
              }} data-id="element-170">
                  <span className="font-semibold" style={{
                  color: '#0289BB'
                }} data-id="element-171">
                    {story.author.split(' ').map(n => n[0]).join('')}
                  </span>
                </div>
                <div data-id="element-172">
                  <p className="font-semibold text-neutral-900" data-id="element-173">
                    {story.author}
                  </p>
                  <p className="text-sm text-neutral-600" data-id="element-174">{story.brand}</p>
                </div>
              </div>
              {/* Content */}
              <div className="prose prose-lg max-w-none" data-id="element-175">
                <p className="text-lg text-neutral-700 leading-relaxed" data-id="element-176">
                  {story.content}
                </p>
              </div>
            </div>
          </div>
          {/* Footer */}
          <div className="sticky bottom-0 bg-white border-t border-neutral-200 px-8 py-6" data-id="element-177">
            <button onClick={handleRepublishClick} className="w-full py-4 text-white rounded-lg hover:shadow-md transition-all font-semibold text-lg" style={{
            background: 'linear-gradient(135deg, #26aedb 0%, #0289BB 50%, #0277a8 100%)'
          }} data-id="element-178">
              Republish This Story
            </button>
          </div>
        </div>
      </div>
      {/* Republish Options Modal */}
      {showRepublishOptions && <RepublishOptionsModal story={story} onClose={() => setShowRepublishOptions(false)} onSelectApi={handleSelectApi} onSelectDownload={handleSelectDownload} data-id="element-179" />}
      {/* Download Content Modal */}
      {showDownloadContent && <DownloadContentModal story={story} onClose={handleCloseDownload} data-id="element-180" />}
    </>;
}